import NewUserConnector from './containers/NewUserConnector';

export default NewUserConnector;
